import { render, staticRenderFns } from "./InternalDept.vue?vue&type=template&id=17afadfd&scoped=true"
import script from "./InternalDept.vue?vue&type=script&lang=js"
export * from "./InternalDept.vue?vue&type=script&lang=js"
import style0 from "./InternalDept.vue?vue&type=style&index=0&id=17afadfd&prod&scoped=true&lang=css"
import style1 from "./InternalDept.vue?vue&type=style&index=1&id=17afadfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17afadfd",
  null
  
)

export default component.exports